import { useApi } from "./api-service";

export interface BrandingData {
  logo?: string;
  brandColor?: string;
  accentColor?: string;
}

export interface BrandingUploadRequest {
  logo?: File;
  brandColor?: string;
  accentColor?: string;
}

export function useBrandingService() {
  const api = useApi();

  return {
    fetchBranding: async (): Promise<BrandingData> => {
      return api.get<BrandingData>("stripe/branding");
    },

    uploadBranding: async (data: BrandingUploadRequest): Promise<void> => {
      const formData = new FormData();
      if (data.logo) {
        formData.append("logo", data.logo);
      }
      if (data.brandColor) {
        formData.append("brandColor", data.brandColor);
      }
      if (data.accentColor) {
        formData.append("accentColor", data.accentColor);
      }
      return api.post<void>("stripe/branding", formData);
    },
  };
}
